import { render, staticRenderFns } from "./AssistantDrawer.vue?vue&type=template&id=6d38e883"
import script from "./AssistantDrawer.vue?vue&type=script&lang=js"
export * from "./AssistantDrawer.vue?vue&type=script&lang=js"
import style0 from "./AssistantDrawer.vue?vue&type=style&index=0&id=6d38e883&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports